import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import dealsReview from './deals-review';
import adminDeals from './admin-deals';

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
	modules:    {
		dealsReview,
		adminDeals
	}
};
